import NavbarLog from '../components/NavbarLog';
import Footer from '../components/Footer';
import SearchPage from '../components/SearchPage';
import { useAuth } from '../utils/AuthContext';
import "../css/Gallery.css";


function Home() {
  const bodytext = '';
  const { user, isAuthenticated, logout } = useAuth();

  return (
    <>
      <NavbarLog />
      <div>
        <SearchPage />
      </div>
      <Footer />       
    </>
  );
}

export default Home;




